<template>
	<div>


		<div v-if="!loginToken">
			<div class="flexheader" style="flex-direction: column; max-width: 300px;gap:10px;">
				<div class="form textField">
					<input type="text" v-model="this.username" placeholder="Username">
					<Circle fileName="w3_close_white" padding="25%" size="20px" color="--grey-5" @click="this.username = null" />
				</div>
				<div class="form textField">
					<input type="password" v-model="this.password" placeholder="Lösenord">
					<Circle fileName="w3_close_white" padding="25%" size="20px" color="--grey-5" @click="this.password = null" />
				</div>
				<div class="flexcenter link"
					style="background:var(--bg-message);padding:5px;border-radius: 5px;color:white;text-align:center;width:150px;"
					@click="login()">
					<div v-if="this.spinner" style="width:20px;background:transparent; ">&nbsp;</div>
					<div class="flexcenter" style="flex-grow:1;height:25px;justify-content: center;"><b>Login</b></div>
					<Icon v-if="this.spinner" fileName="spinner" class="spinner"
						style="margin-right:0px;width:20px;height:20px;" />
				</div>

				


			</div>

		</div>
		<div v-if="loginToken">
			<div v-if="this.debug" class="flexheader debug" style="margin-bottom:10px;">
				<Button label="Logout" v-if="loginToken" :spinIconRight="this.spinner == true" class="grey"
					:iconRight="this.spinner ? 'spinner.png' : null" @click="logout()" />

				<Button label="Radera token" v-if="loginToken" class="grey" @click="deleteToken" />

			

				<div style="display:flex;align-items:center;" v-if="loginToken">
					LT: {{ loginToken.substring(0,4) }}... Timer: {{ this.timer }}
				</div>
				<b style="flex-grow:1;">&nbsp;</b>

				<Button label="Förläng session" v-if="loginToken" class="grey" @click="append" :badge="sessionStatus" />
				<Button label="Stäng" @click="this.$emit('hideAllSubmenu')" />
			</div>
			<ResellerNews v-if="this.showResellerNewsAfterLogin" :isPopover="true"
				@hideAllSubmenu="(() => this.$emit('hideAllSubmenu'))" />
		</div>
	</div>
</template>

<script>
import { STORE_ACTION, STORE_COMMIT, STORE_GETTER } from '../store/store';
import { logMixin } from "@/mixins/logMixin.js";
import { userMixin } from "@/mixins/userMixin.js";
import { USER_STORE_COMMIT } from '../store/user-store';
import ResellerNews from '../components/user/ResellerNews.vue';

export default {
	name: "Login",
	mixins: [logMixin, userMixin],
	components: { ResellerNews },
	data() {

		var data = {
			spinner: false,
			username: "",
			password: "",
			timer: null,
			sessionStatus: "",
			showResellerNewsAfterLogin: true

		}

		if (process.env.NODE_ENV == "development") {
			data.username = "freddewww@x-web.se";
			data.password = "Pass"
		}

		return data;
	},
	computed: {
		loginToken() {
			return this.$store.getters[STORE_GETTER.LOGIN_TOKEN]
		}
	},
	methods: {
		login() {


			if (!this.username || this.username.length < 4) {
				alert("Ange e-post eller användarnamn");
				return;
			}

			if (!this.password || this.password.length < 4) {
				alert("Ange lösenord");
				return;

			}

			if (this.$route?.name == "ResellerNews"){
				this.showResellerNewsAfterLogin = false;
			}

			this.spinner = true

			this.$store.commit(STORE_COMMIT.SET_LOGIN_TOKEN, null)

			const context = this;

			this.$store.dispatch({ type: STORE_ACTION.LOGIN, data: { username: this.username, password: this.password } }).then(result => {



				console.log('FP: login result: ', result);

				if (this.loginToken != null) {

					

					//this.$store.dispatch({ type: USER_STORE_ACTION.GET_USER_MODEL, data: {} })

					this.timer = setInterval(() => {
						context.loginStatus();
					}, context.$store.state.loginStatusInterval * 1000 * 1);

					if (!this.showResellerNewsAfterLogin){
						this.$emit("hideAllSubmenu")
					}
				}




			}).catch(error => {

				console.log('FP: login error', error);


			}).finally(() => {
				this.spinner = false
			})


			// 
			//this.$store.commit(STORE_COMMIT.SET_LOGIN_TOKEN, "abc123")
			//const context = this;

			/*this.timer = setInterval(() => {
				context.loginStatus();
			}, context.$store.state.loginStatusInterval * 1000 * 1); // 120 sekunder (verkar hämta värde från settings)*/

		},
		loginStatus() {
			var message = "LoginStatus: token: " + this.loginToken?.substring(0, 5) + "*** " + " timer: " + this.timer
			this.logOK(message)
			console.log('FP: ', message);

			if (this.loginToken == null) {

				this.logOK("loginToken saknas, avbryter timer. Timer: " + this.timer)
				clearInterval(this.timer);
				this.timer = "";

			} else {
				this.$store.dispatch({ type: STORE_ACTION.GET_STATUS, data: {} }).then(result => {

					if (result && result.status == "OK" && result.sessionStatus) {

						this.sessionStatus = result.sessionStatus

					}

					if (result && result.header == 401) {

						this.sessionStatus = "NONE"

						this.logOK("status, header 401, avbryter timer. Timer: " + this.timer)
						clearInterval(this.timer);
						this.timer = "";

						this.$store.commit(STORE_COMMIT.SET_LOGIN_TOKEN, null);
						this.$store.commit(USER_STORE_COMMIT.DELETE_USER_MODEL);
						return;
					}



				})
			}

		},
		logout() {
			this.logOK("Logout")

			if (!window.confirm("Vill du logga ut?")){
				return;
			}

			clearInterval(this.timer);
			this.timer = "";

			this.$store.dispatch({ type: STORE_ACTION.LOGOUT, data: {} })

		},
		append() {
			this.$store.dispatch({ type: STORE_ACTION.APPEND, data: {} })
		},
		deleteToken() {
			this.$store.commit(STORE_COMMIT.SET_LOGIN_TOKEN, null)
		},
		
	},
	
	
};
</script>

<style scoped></style>
